import { ref, computed } from "vue";

// Registro de "fuentes" con edición sin guardar (historia clínica, turno, datos del
// paciente, etc.). La usa la auto-actualización del service worker (main.js) para NO
// recargar la página mientras se está escribiendo algo, y así no perder texto a medias.
//
// Antes esto era un solo booleano. Eso fallaba si dos formularios estaban abiertos a la
// vez (p. ej. historia y datos del paciente en la misma ficha): al cerrarse uno ponía la
// bandera en false y habilitaba la recarga aunque el otro siguiera con texto sin guardar.
// Ahora cada formulario registra su propia clave y la bandera global está activa mientras
// CUALQUIERA lo esté.
const fuentesConEdicion = ref(new Set());

// Marca (true) o desmarca (false) una fuente de edición pendiente, por clave.
export function marcarEdicion(clave, hay) {
  const set = fuentesConEdicion.value;
  if (hay) set.add(clave);
  else set.delete(clave);
  // Reasignamos el Set para disparar la reactividad (mutarlo in-place no la dispara).
  fuentesConEdicion.value = new Set(set);
}

// ¿Hay alguna edición sin guardar en cualquier formulario?
//
// Es un computed ESCRIBIBLE a propósito: HistoriaClinica ya usa `hayEdicionSinGuardar.value
// = hay` y lo seguimos soportando (se mapea a su propia clave). Así no hay que tocar ese
// componente, que ya está probado. Los formularios nuevos usan `marcarEdicion(clave, hay)`.
export const hayEdicionSinGuardar = computed({
  get: () => fuentesConEdicion.value.size > 0,
  set: (hay) => marcarEdicion("historia-clinica", hay),
});
